// cSpell:ignore unmount
import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { setItemModel } from "../../actions/listing";
import OrderSearch from "./OrderSearch";
import Listing from "../Listing";

class OrderListing extends Component {
  static propTypes = {
    // Injected by React-Router
    history: PropTypes.object.isRequired,
    // Injected by React-Redux
    userGroup: PropTypes.string.isRequired,
    setItemModel: PropTypes.func.isRequired,
  };

  model = "order";

  componentWillMount = () => {
    this.props.setItemModel(this.model);
  };

  render() {
    const { history, userGroup } = this.props,
      fields = {
        serial: { title: "#", type: "serial" },
        _id: { title: "ID" },
        ip: { title: "IP", sortable: true },
        secondaryIp: { title: "Secondary IP", sortable: true },
        type: { title: "Type", sortable: true },
        servers: { title: "Servers", type: "number", sortable: true },
        billingCycle: {
          title: "Billed (months)",
          type: "number",
          sortable: true,
        },
        "price.amount": { title: "Price", type: "number", sortable: true },
        autoRenew: { title: "Auto renew", type: "bool" },
        status: { title: "Status", sortable: true },
      },
      actions = [
        {
          name: "View",
          type: "primary",
          icon: "eye",
          handler: (id) => {
            history.push(`/${this.model}/view/${id}`);
          },
        },
      ];
    if ("customer" !== userGroup) {
      fields.customer = {
        title: "Customer ID",
        link: "/customer/edit/",
      };
    }
    fields.created = {
      title: "Created",
      type: "date",
      format: "YYYY-MM-DD",
      sortable: true,
    };
    fields.actions = { title: "Actions", type: "actions" };
    return (
      <Listing
        title="Orders"
        model={this.model}
        mainField="_id"
        // list config
        fields={fields}
        actions={actions}
        highlightFields={{ ip: 1, secondaryIp: 1 }}
        highlightTextPath={{ ip: ["$or", 0], secondaryIp: ["$or", 1] }}
        defaultSort={{ created: -1 }}
        // search form component
        ItemSearch={OrderSearch}
        simpleSearchTitle="IP Address"
        getSimpleSearch={(search) => ({
          $or: [{ ip: search }, { secondaryIp: search }],
        })}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  userGroup: state.auth.user.group,
});

export default withRouter(
  connect(mapStateToProps, {
    setItemModel,
  })(OrderListing)
);
